import templates from './templates.json' assert { type: 'json' };

export { templates };

export const NO_TEMPLATE = 'NO_TEMPLATE';

export type Templates = typeof templates;
export type TemplateID = keyof Templates['starters'];
export type BuildConfig = { command: string; output: string; env?: Record<string, string> };

export function getBuildConfig(template: TemplateID) {
  const build = (templates.starters[template] as any)?.build as BuildConfig | TemplateID;

  if (typeof build === 'string') {
    // if the value is a string, it's pointing to another build config
    return getBuildConfig(build);
  }

  return build;
}
